import { useMutation } from '../services/NetworkManager';
import { NetworkManager } from '../services';

export type SipFrequency = 'DAILY' | 'WEEKLY' | 'MONTHLY';

export type DayOfWeek =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY';

export type CalculateStartDatePayloadWithDate = {
  subscriptionFrequency: 'DAILY';
  fromDate: string;
};

export type CalculateStartDatePayloadWithDay = {
  subscriptionFrequency: 'WEEKLY';
  fromDay: DayOfWeek;
};

export type CalculateStartDatePayloadWithMonthDay = {
  subscriptionFrequency: 'MONTHLY';
  fromDay: string;
};

export type CalculateStartDatePayload =
  | CalculateStartDatePayloadWithDate
  | CalculateStartDatePayloadWithDay
  | CalculateStartDatePayloadWithMonthDay;

export type StartDateResponse = {
  startDate?: string;
};

export function calculateSipStartDate(payload: CalculateStartDatePayload) {
  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.sipStartDate,
    data: payload,
  });
}

export default function useSipStartDate() {
  const mutation = useMutation(calculateSipStartDate);

  return {
    calculateStartDate: mutation.mutate,
    calculateStartDateAsync: mutation.mutateAsync,
    data: mutation.data as StartDateResponse | undefined,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  };
}
